import React from 'react';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { googleLinkRute, izostavljenoTacaka, MAX_MEDJUTACAKA } from './googleLinkovi';

/* Merenje udaljenosti — panel koji stoji nad mapom dok merenje traje.

   Jedan mehanizam pokriva dva ulaza koja korisnik doživljava kao različita:
   lenjir („koliko ima odavde dotle") i postavljanje početne/završne tačke rute.
   Oba su niz tačaka kroz koje se traži kamionska ruta, pa se i vode kao jedan
   spisak — druga izvedba bi značila dve linije na mapi koje se ne slažu.

   Tačka se dodaje na tri načina: klikom na mapu, izborom iz pretrage i preko
   menija na pinu. Zato panel uvek ispisuje ČIME se dodaje — bez toga operater
   klikne jednom, ništa se ne desi tamo gde je očekivao, i odustane.

   Rezultat je uvek kamionski profil, isti kao u nalozima. Vazdušna linija se
   ovde ne nudi ni kao rezerva: merač koji ponekad meri vazduh a ponekad put
   ne može da se čita. */

const PanelMerenje = ({
    tacke, rezultat, ucitava, poruka,
    onUkloni, onOcisti, onZatvori,
}) => {
    const { t } = useTranslation();

    const dovoljno = (tacke || []).length >= 2;

    /* Ista merena trasa, ali u Google navigaciji — dispecer je izmeri ovde,
       pa link posalje vozacu. Deep link ne trosi kvotu i ne trazi kljuc.

       Google prima najvise devet medjutacaka; visak se sece i to se KAZE,
       jer ruta u Google-u tada nije ista kao ova na nasoj mapi. */
    const googleVeza = googleLinkRute(tacke);
    const izostavljeno = izostavljenoTacaka(tacke);

    return (
        <div className="gps-mer">
            <div className="gps-mer-zaglavlje">
                <span className="gps-mer-naslov">
                    <i className="pi pi-directions" />
                    {t('gps.merenjeNaslov')}
                </span>
                <button type="button" className="gps-mer-x" onClick={onZatvori}
                        title={t('gps.merenjeZatvori')} aria-label={t('gps.merenjeZatvori')}>
                    <i className="pi pi-times" />
                </button>
            </div>

            <div className="gps-mer-uputstvo">{t('gps.merenjeUputstvo')}</div>

            <ol className="gps-mer-spisak">
                {(tacke || []).map((tc, i) => (
                    <li key={`${tc.lat}-${tc.lng}-${i}`}>
                        {/* Prva i poslednja tačka se razlikuju bojom, ne samo
                            brojem: kod rute je bitno šta je polazak a šta cilj,
                            a broj se čita tek posle boje. */}
                        <span className={`gps-mer-broj${i === 0 ? ' gps-mer-broj-prvi' : ''}${i === tacke.length - 1 && tacke.length > 1 ? ' gps-mer-broj-zadnji' : ''}`}>
                            {i + 1}
                        </span>
                        <span className="gps-mer-naziv" title={tc.naziv}>{tc.naziv}</span>
                        <button type="button" className="gps-mer-ukloni" onClick={() => onUkloni(i)}
                                title={t('gps.merenjeUkloniTacku')} aria-label={t('gps.merenjeUkloniTacku')}>
                            <i className="pi pi-times" />
                        </button>
                    </li>
                ))}
            </ol>

            {!dovoljno && (
                <div className="gps-mer-cekanje">{t('gps.merenjeDodajJos')}</div>
            )}

            {dovoljno && ucitava && (
                <div className="gps-mer-cekanje">
                    <i className="pi pi-spin pi-spinner" /> {t('gps.merenjeRacuna')}
                </div>
            )}

            {dovoljno && !ucitava && !!poruka && (
                <div className="gps-mer-greska">{poruka}</div>
            )}

            {dovoljno && !ucitava && !poruka && !!rezultat && (
                <div className="gps-mer-zbir">
                    <div className="gps-mer-stavka">
                        <span className="gps-mer-broj-veliki">
                            {rezultat.km.toLocaleString('sr-RS', { maximumFractionDigits: 1 })}
                        </span>
                        <span className="gps-mer-jedinica">km</span>
                    </div>
                    <div className="gps-mer-stavka">
                        <span className="gps-mer-broj-veliki">
                            {Math.floor(rezultat.minuta / 60)}h {rezultat.minuta % 60}min
                        </span>
                        <span className="gps-mer-jedinica">{t('gps.merenjeVoznja')}</span>
                    </div>
                </div>
            )}

            {!!googleVeza && !!izostavljeno && (
                <div className="gps-mer-napomena">
                    {t('gps.merenjeGoogleIzostavljeno', { broj: izostavljeno, najvise: MAX_MEDJUTACAKA })}
                </div>
            )}

            <div className="gps-mer-podnozje">
                <Button
                    type="button"
                    icon="pi pi-trash"
                    label={t('gps.merenjeOcisti')}
                    className="p-button-text p-button-sm"
                    disabled={!(tacke || []).length}
                    onClick={onOcisti}
                />
                <Button
                    type="button"
                    icon="pi pi-external-link"
                    label={t('gps.merenjeGoogle')}
                    className="p-button-text p-button-sm"
                    disabled={!googleVeza}
                    onClick={() => window.open(googleVeza, '_blank', 'noopener,noreferrer')}
                />
            </div>
        </div>
    );
};

export default PanelMerenje;
